// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"afa902bf","176":"70eebf6a","733":"d229b3e8"}[chunkId] + ".chunk.css";
};